export default {
    LOAD_PRODUCT_MEASURES (state, productmeasures) {
        state.items = productmeasures
    }
}